import { render, staticRenderFns } from "./AddLocationServiceContact.vue?vue&type=template&id=b4851ef2&scoped=true"
import script from "./AddLocationServiceContact.vue?vue&type=script&lang=js"
export * from "./AddLocationServiceContact.vue?vue&type=script&lang=js"
import style0 from "./AddLocationServiceContact.vue?vue&type=style&index=0&id=b4851ef2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4851ef2",
  null
  
)

export default component.exports